export async function updateApplicationSettings({ minPrice, maxPrice, paymentPlans, allowAll, restrictionLevel }) {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=apasi_update_application_settings`, {
    method: "POST",
    body: JSON.stringify({
      minPrice,
      maxPrice,
      paymentPlans,
      allowAll,
      restrictionLevel,
    }),
    headers: {
      "Content-Type": "application/json"
    },
    credentials: "include"
  });

  if (response.ok) {
    const body = await response.json();
    if (body && body.error) {
      return Promise.reject({error: body.error});
    }
    return Promise.resolve();
  }

  return Promise.reject();
}

export async function loadApplicationSettings() {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=apasi_load_application_settings`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    },
    credentials: "include"
  });

  if (response.ok) {
    return response.json();
  }

  return Promise.reject();
}

export async function setActiveAgency({ type, id }) {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=set_active_agency`, {
    method: "POST",
    body: JSON.stringify({
      type,
      id,
    }),
    headers: {
      "Content-Type": "application/json"
    },
    credentials: "include"
  });

  if (response.ok) {
    const body = await response.json();
    if (body && body.error) {
      return Promise.reject({ error: body.error });
    }

    return true;
  }

  return false;
}
